import React, { useContext, useEffect, useState } from "react";
import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import PackagesForm from "./PackagesForm";
import btnStyles from "../../../../styles/Custom/Button.module.css";
import { UserContext } from "../../../../context/UserContext";
import { getPackages } from "../../../../services/service.services";
import PackageTable from "./PackageTable";
import { getCookie } from "../../../../helpers/localStorage";
import { FacilityID, Role } from "../../../../constants/defaultKeys";
import { UiDataTable } from "../../../ui";
import useQuery from "../../../../hooks/useQuery";
import {
  parseSearchParam,
  updateUrlSearchParams,
} from "../../../../helpers/urlFilters";

const Packages = () => {
  const navigate = useNavigate();
  const params = useQuery();
  const searchQuery = parseSearchParam(params);
  const { userDetails } = useContext(UserContext);
  const [visible, setVisible] = useState(false);
  const [packageData, setPackageData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  const refreshPackages = () => {
    setRefresh((prev) => !prev);
  };

  useEffect(() => {
    const rawFacilityId =
      getCookie(FacilityID) ?? userDetails?.currFacility;

    const facilityId = Number(rawFacilityId);

    setLoading(true);

    getPackages(
      Number.isFinite(facilityId) ? `facility=${facilityId}` : ""
    )
      .then((res) => {
        const allPackages = res?.data?.data || [];

        const facilityPackages = Number.isFinite(facilityId)
          ? allPackages.filter(
              (pkg) => pkg?.facility_id === facilityId
            )
          : allPackages;

        setPackageData(facilityPackages);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, [refresh, userDetails]);

  useEffect(() => {
    const query = (searchQuery || "").toLowerCase();
    if (!query) {
      setFilteredData(packageData ?? []);
      return;
    }
    setFilteredData(
      packageData?.filter((pack) =>
        pack?.name?.toLowerCase()?.includes(query)
      ) ?? []
    );
  }, [packageData, searchQuery]);

  const defaultRole = userDetails?.currRole || getCookie(Role);

  const onPackageSearch = (e) => {
    const query = e?.target?.value || "";
    updateUrlSearchParams(navigate, { search: query || null });
  };

  const showAddPackage =
    defaultRole !== "Facility_Admin" && defaultRole !== "Receptionist";

  return (
    <>
      <UiDataTable
        showHeader={false}
        shellClassName="ui-table-fill-shell"
        onSearch={onPackageSearch}
        searchValue={searchQuery}
        searchPlaceholder="Search package"
        toolbarTrailing={
          showAddPackage ? (
            <Button
              type="primary"
              className={btnStyles.mdBtn}
              onClick={() => setVisible(true)}
            >
              <PlusOutlined /> Package
            </Button>
          ) : null
        }
      >
        <PackageTable
          data={filteredData}
          loading={loading}
          refreshPackages={refreshPackages}
          userDetails={userDetails}
        />
      </UiDataTable>
      {visible && (
        <PackagesForm
          visible={visible}
          setVisible={setVisible}
          refreshPackages={refreshPackages}
        />
      )}
    </>
  );
};

export default Packages;
